module.exports = __webpack_public_path__ + "img/logo-zc-edasneo.75189c8e.webp";